import { OPEN_STATUS_IDS } from '@btime/constants'
import { path, prop } from 'ramda'
import { useLoggedUser, useSessionPermission } from '@btime/react-session'

// TODO: Use STATUS from @btime/constants
const resumeStatuses = [
  'completed',
  'approved',
  'pending',
  'disapproved',
  'unproductive',
  'canceled',
  'refused',
  'disapproved',
  'closing'
]
const executeStatuses = ['received', 'open', 'execution', 'pause']
const editUserStatuses = ['request', 'open', 'refused', 'unproductive']

export const useServiceOrderPermissions = serviceOrder => {
  const canAssign = !!serviceOrder?.userGroup
  const canEdit = useSessionPermission('editServiceOrder')
  const canDelete = useSessionPermission('deleteServiceOrder')
  const canOpenServiceOrderRetroactive = useSessionPermission('retroactiveServiceOrder')
  const hasResumePermission = useSessionPermission('seeServiceOrdersResume')
  const canExecuteFromWeb = useSessionPermission('canExecuteFromWeb')
  const canEditFinishedServiceOrders = useSessionPermission('canEditFinishedServiceOrders')

  const loggedUser = useLoggedUser()
  const userId = path(['user', 'id'], serviceOrder) || prop('userId', serviceOrder)
  const statusName = path(['serviceStatus', 'name'], serviceOrder) || path(['status', 'name'], serviceOrder)

  const isDumb =
    (!serviceOrder?.checklist && !serviceOrder?.place && !serviceOrder?.group && !serviceOrder?.userId) ||
    (!serviceOrder?.checklist && !serviceOrder?.group && !serviceOrder?.userId)

  const canSeeResumeByStatus = resumeStatuses.includes(statusName) || isDumb

  const canSeeResume = canSeeResumeByStatus && hasResumePermission

  const canSeePublicLink = useSessionPermission('seeServiceOrdersPublicResumeLink') && canSeeResumeByStatus

  const canSeeExecutionPublicLink = OPEN_STATUS_IDS.includes(serviceOrder?.status?.id)

  return {
    canAssign,
    canSeeResume,
    canSeePublicLink,
    canSeeExecutionPublicLink,
    canExecute: executeStatuses.includes(statusName) && loggedUser.id === userId,
    canEditUser: editUserStatuses.includes(statusName) && canEdit,
    canEdit,
    canDelete,
    canOpenServiceOrderRetroactive,
    canExecuteFromWeb,
    canEditFinishedServiceOrders
  }
}
